import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ENTranslations from "./locales/en.json";
import HKTranslations from "./locales/hk.json";
import CNTranslations from "./locales/cn.json";
import { ThemeProvider } from "@mui/material";
import theme from "./styles/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    supportedLngs: ["en", "hk", "cn"],
    resources: {
      en: {
        translation: ENTranslations,
      },
      hk: {
        translation: HKTranslations,
      },
      cn: {
        translation: CNTranslations,
      },
    },
    fallbackLng: "en",
    detection: {
      order: ["cookie", "localStorage", "navigator", "htmlTag", "querystring"],
      caches: ["cookie"],
    },
  });

root.render(
  //<React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
